<template>
  <p>
    <strong>Add to:</strong>
    <a class="alt" target="_blank" :href="calendarLinks.google">Google</a>&nbsp;
    <a class="alt" download="event.ics" :href="calendarLinks.ical">iCal</a>&nbsp;
    <a class="alt" download="event.ics" :href="calendarLinks.outlook">Outlook</a>
  </p>
</template>

<script>
import { createCalendar } from '../utils/calendars'
export default {
  props: {
    title: !String,
    start: !String,
    end: !String,
    tz: !String,
    description: String,
    address: String
  },
  computed: {
    calendarLinks () {
      return createCalendar({
        title: this.title,
        start: this.start,
        end: this.end,
        tz: this.tz,
        description: this.description,
        address: this.address
      })
    }
  }
}
</script>
